// src/theme.js
import { createTheme } from '@mui/material/styles';

export const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary:   { main: '#4aa3ff' },
    secondary: { main: '#5664d2' },
  },
});

export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary:   { main: '#4aa3ff' },
    secondary: { main: '#5664d2' },
    background: {
      default: '#2b3244',  // ← page/body background
      paper:   '#252b3b',  // ← MUI Paper, Dialogs, Tables, etc.
    },
    text: {
      primary:   '#ffffff',
      secondary: '#bbbbbb',
    },
  },
});
